import BaseModelAPI from '../BaseModelAPI';

export default class PostingSupplyForProduction extends BaseModelAPI {
	static entity = 'postingsupplyforproduction';
	static entityName = 'postingsupplyforproduction';

	constructor() {

		/*APP_MODEL_DEFINITION*/
		this.id = '';
		this.pickingSupplyForProductionId = '';
		this.pickingSupplyForProduction = {};
		this.workOrderSupplyId = '';
		this.workOrderSupply = {};
		this.workOrderProcessId = '';
		this.workOrderProcess = {};
		this.lineId = '';
		this.line = {};
		this.workOrderSupplyDate = '';
		this.documentStatusId = '';
		this.documentStatus = {};
		this.postingSupplyDetailForProduction = []
		this.postingSupplyCase = []
		this.isFromUpload = false;
		this.isSavedToBackend = true;
		this.isScanned = '';
		this.uploadValidationMessage = '';
		this.uploadValidationStatus = '';
		/*END_APP_MODEL_DEFINITION*/
	}

	static async scanPic(this_, id, picpicking, picpenerima) {
		let data = new Object();
		data.picpicking = picpicking;
		data.picpenerima = picpenerima;
		return this_.$http.put(`${this.entityName}/scanpic/${id}`, data)
			.then(async function (response) {
				if (response.data) {
					return response.data;
				}
				return null;
			})
			.catch(function (error) {
				var stringError = 'Gagal melakukan Scan Pic!';
				if (error != null && error != undefined && error.response != null && error.response != undefined && error.response.data != null && error.response.data != undefined && error.response.data.errors != undefined && error.response.data.errors != null) {
					let errorList = Object.values(error.response.data.errors);
					stringError = "";
					errorList.forEach(err => {
						if (stringError != "") {
							stringError += " \r\n "
						}
						stringError += err;
					})
				}
				this_.toast({ message: stringError, title: 'Error', variant: 'danger' });
				throw error;
			});
	}
	static async scanRack(this_, id, rack) {
		let data = new Object();
		data.rackScan = rack;
		return this_.$http.put(`${this.entityName}/scanRack/${id}`, data)
			.then(async function (response) {
				if (response.data) {
					return response.data;
				}
				return null;
			})
			.catch(function (error) {
				var stringError = 'Gagal melakukan Scan Rack!';
				if (error != null && error != undefined && error.response != null && error.response != undefined && error.response.data != null && error.response.data != undefined && error.response.data.errors != undefined && error.response.data.errors != null) {
					let errorList = Object.values(error.response.data.errors);
					const errorObj = errorList.find(() => true);
					stringError = errorObj[0];
				}
				this_.toast({ message: stringError, title: 'Warning', variant: 'warning' });
				throw error;
			});
	}

	static async finishScan(this_, id) {
		return this_.$http.put(`${this.entityName}/finishscan/${id}`)
			.then(async function (response) {
				if (response.data) {
					return response.data;
				}
				return null;
			})
			.catch(function (error) {
				var stringError = 'Gagal melakukan Finish Scan!';
				if (error != null && error != undefined && error.response != null && error.response != undefined && error.response.data != null && error.response.data != undefined && error.response.data.errors != undefined && error.response.data.errors != null) {
					let errorList = Object.values(error.response.data.errors);
					const errorObj = errorList.find(() => true);
					stringError = errorObj[0];
				}
				this_.toast({ message: stringError, title: 'Error', variant: 'danger' });
				throw error;
			});
	}
}